import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { SharedService } from 'src/app/services/shared.service';


@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [MatBadgeModule, MatButtonModule, MatIconModule, MatCardModule,
    FormsModule
  ],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent {
  companyData:any={};
  fullname:string = '';
  is_edit=false;
  constructor(private shareService: SharedService){
    let data:any = this.shareService.userInfo;
    this.fullname = data['first_name'] +' '+data['last_name']
    let include = [
      "companies",
      "full_name",
      "primary_email_id",
      "phone_number"]

    include.map(e=>{
      if(e == 'companies'){
        this.companyData['Company'] = data[e];
      }else{
        this.companyData[e] = data[e];
      }
    })
  }

  update(){
    this.is_edit = !this.is_edit;
  }

  getLabel(val:string=''){
    return val.replaceAll('_',' ');
  }
  getKyes(Obj:any){
    return Object.keys(Obj);
  }

  updateUserName(name:string){
    if(name){
      let nameList = name.split(' ');
      console.log(nameList);
      
    }
  }
}
